module.exports = __webpack_public_path__ + "media/hero_mv.fb3a18c0.mp4";